import { render, staticRenderFns } from "./CcPreviewCard.ts.vue?vue&type=template&id=624f9208"
import script from "./CcPreviewCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcPreviewCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcPreviewCard.ts.vue?vue&type=style&index=0&id=624f9208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports